const shimmer = 'rgba(247,246,242,0.06)';

function Block({ w, h, mb = 0 }: { w: string | number; h: number; mb?: number }) {
  return (
    <div className="animate-pulse" style={{
      width: typeof w === 'number' ? w : w,
      height: h,
      backgroundColor: shimmer,
      marginBottom: mb,
    }} />
  );
}

export function SAHomeSkeleton() {
  return (
    <div style={{ padding: 0 }}>
      <Block w={100} h={13} mb={24} />
      {/* Alert card */}
      <div style={{ backgroundColor: 'rgba(247,246,242,0.04)', border: '0.5px solid rgba(247,246,242,0.12)', padding: 16, marginBottom: 24 }}>
        <Block w={140} h={10} mb={16} />
        <Block w="80%" h={13} mb={10} />
        <Block w="60%" h={13} />
      </div>
      {/* KPIs */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 12, marginBottom: 24 }}>
        {[...Array(4)].map((_, i) => (
          <div key={i} style={{ backgroundColor: 'rgba(247,246,242,0.04)', border: '0.5px solid rgba(247,246,242,0.12)', padding: 16 }}>
            <Block w={80} h={10} mb={12} />
            <Block w={60} h={20} mb={8} />
            <Block w={100} h={11} />
          </div>
        ))}
      </div>
      {/* Quick actions */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 24 }}>
        <Block w="50%" h={40} />
        <Block w="50%" h={40} />
      </div>
      {/* Recent users */}
      <Block w={120} h={10} mb={16} />
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {[...Array(2)].map((_, i) => (
          <div key={i} style={{ backgroundColor: 'rgba(247,246,242,0.04)', border: '0.5px solid rgba(247,246,242,0.12)', padding: 16, display: 'flex', alignItems: 'center', gap: 12 }}>
            <Block w={36} h={36} />
            <div style={{ flex: 1 }}>
              <Block w={100} h={13} mb={6} />
              <Block w={160} h={11} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function SAUsersSkeleton() {
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 20 }}>
        <Block w={80} h={13} />
        <Block w={120} h={32} />
      </div>
      <Block w="100%" h={40} mb={16} />
      <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
        {[...Array(5)].map((_, i) => <Block key={i} w={60 + i * 10} h={28} />)}
      </div>
      {[...Array(5)].map((_, i) => (
        <div key={i} style={{ backgroundColor: 'rgba(247,246,242,0.04)', border: '0.5px solid rgba(247,246,242,0.12)', padding: 16, marginBottom: 8 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
            <Block w={36} h={36} />
            <div style={{ flex: 1 }}>
              <Block w={120} h={13} mb={4} />
              <Block w={180} h={11} />
            </div>
          </div>
          <div style={{ display: 'flex', gap: 16 }}>
            <Block w={80} h={11} />
            <Block w={60} h={11} />
            <Block w={70} h={11} />
          </div>
        </div>
      ))}
    </div>
  );
}

export function SAInvitesSkeleton() {
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 20 }}>
        <Block w={80} h={13} />
        <div style={{ display: 'flex', gap: 8 }}>
          <Block w={100} h={32} />
          <Block w={80} h={32} />
        </div>
      </div>
      <div style={{ display: 'flex', gap: 6, marginBottom: 20 }}>
        {[...Array(6)].map((_, i) => <Block key={i} w={65} h={26} />)}
      </div>
      {[...Array(4)].map((_, i) => (
        <div key={i} style={{ backgroundColor: 'rgba(247,246,242,0.04)', border: '0.5px solid rgba(247,246,242,0.12)', padding: 16, marginBottom: 8 }}>
          <Block w={100} h={13} mb={12} />
          <Block w="80%" h={11} mb={6} />
          <Block w="60%" h={11} />
        </div>
      ))}
    </div>
  );
}

export function SAWaitlistSkeleton() {
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 24 }}>
        <Block w={120} h={18} />
        <Block w={80} h={28} />
      </div>
      {[...Array(5)].map((_, i) => (
        <div key={i} style={{ backgroundColor: 'rgba(247,246,242,0.04)', border: '0.5px solid rgba(247,246,242,0.12)', padding: 16, marginBottom: 8, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <Block w={200} h={13} mb={6} />
            <Block w={80} h={11} />
          </div>
          <Block w={80} h={28} />
        </div>
      ))}
    </div>
  );
}

export function SAFinanceiroSkeleton() {
  return (
    <div>
      <Block w={100} h={13} mb={24} />
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 12, marginBottom: 24 }}>
        {[...Array(4)].map((_, i) => (
          <div key={i} style={{ backgroundColor: 'rgba(247,246,242,0.04)', border: '0.5px solid rgba(247,246,242,0.12)', padding: 16 }}>
            <Block w={80} h={10} mb={12} />
            <Block w={60} h={20} mb={8} />
            <Block w={100} h={11} />
          </div>
        ))}
      </div>
      <Block w={140} h={10} mb={16} />
      {[...Array(3)].map((_, i) => (
        <div key={i} style={{ backgroundColor: 'rgba(247,246,242,0.04)', border: '0.5px solid rgba(247,246,242,0.12)', padding: 16, marginBottom: 8 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
            <Block w={60} h={13} />
            <Block w={100} h={11} />
          </div>
          <Block w="100%" h={6} />
        </div>
      ))}
    </div>
  );
}

export function SAProfileSkeleton() {
  return (
    <div>
      <Block w={80} h={13} mb={24} />
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 24 }}>
        <Block w={50} h={50} />
        <div>
          <Block w={140} h={18} mb={6} />
          <Block w={200} h={13} mb={4} />
          <Block w={160} h={11} />
        </div>
      </div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 32 }}>
        <Block w={100} h={36} />
        <Block w={110} h={36} />
        <Block w={130} h={36} />
      </div>
      {[...Array(6)].map((_, i) => (
        <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '12px 0', borderBottom: '0.5px solid rgba(247,246,242,0.12)' }}>
          <Block w={120} h={11} />
          <Block w={100} h={13} />
        </div>
      ))}
    </div>
  );
}
